import {
  Component,
  OnInit,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss'],
})
export class AIChatComponent implements OnInit {
  public isPending: boolean = false;

  constructor(
    private location: Location
  ) {}

  ngOnInit() {}

  openchat() {
    // AI Chat Initiation Logic Here
  }

  goBack() {
    this.location.back();
  }
}
